@let quote = smartquote();

<div class="pb-2">
    <h1 class="text-dark">Smart Quote</h1>

    @if (quote) {
        <div class="d-flex gap-1 mb-2">
            <span
                class="badge"
                [class.text-bg-dark]="!quote.accepted && !quote.declined"
                [class.text-bg-danger]="quote.declined"
                [class.text-bg-success]="quote.accepted"
                >{{ quote.accepted ? 'Quote Accepted' : quote.declined ? 'Quote Declined' : 'Awaiting Customer' }}</span
            >

            <span
                class="badge"
                [class.text-bg-danger]="!quote.hasOrderBeenPlaced"
                [class.text-bg-success]="quote.hasOrderBeenPlaced"
                >{{ quote.hasOrderBeenPlaced ? 'Parts Ordered' : 'Awaiting Order' }}</span
            >

            <span
                class="badge"
                [class.text-bg-danger]="!quote.appointmentId"
                [class.text-bg-success]="quote.appointmentId"
                >{{ quote.appointmentId ? 'Appointment Booked' : 'No Appointment Booked' }}</span
            >
        </div>
        <div class="d-flex small justify-content-between align-items-center">
            <p class="mb-2">
                Created by <b>{{ quote.createdBy.fullName }}</b> on {{ quote.created | date: 'EEEE dd MMMM yyyy' }} at
                {{ quote.created | date: 'HH:mma' }}.
            </p>
            <p class="mb-0 align-self-center">
                Acceptance link:
                <a icon="external-link" [href]="quote.acceptanceUrl" target="_blank" color="clear">{{
                    quote.acceptanceUrl
                }}</a>
            </p>
        </div>
    }

    @if (smartquote(); as smartquote) {
        <div class="d-flex justify-content-between">
            <div>
                <button
                    sfButton
                    size="sm"
                    color="info"
                    icon="file-pdf"
                    tooltip="View the PDF version of this quote"
                    tooltipContainer="body"
                    (click)="openPDFModal()">
                    View PDF
                </button>
                <button
                    sfButton
                    size="sm"
                    color="secondary"
                    tooltip="Email this quote to the customer"
                    tooltipContainer="body"
                    icon="external-link"
                    (click)="openEmailModal()">
                    Email Quote (to customer)
                </button>
                <a
                    [hidden]="quote?.appointmentId"
                    sfButton
                    size="sm"
                    color="secondary"
                    routerLink="/diary/calendar"
                    tooltip="Create an appointment associated with this quote"
                    tooltipContainer="body"
                    [queryParams]="{
                        smartQuoteId: smartquote.id,
                        smartQuoteTotal: totalExVatCost(),
                        smartQuoteDeposit: deposit(),
                        customerId: smartquote.customerId,
                    }"
                    icon="calendar"
                    >Create Appointment</a
                >
            </div>
            <div>
                <button sfButton size="sm" color="secondary" icon="external-link" (click)="openSendOrderModal()">
                    Send Order
                </button>
                <ng-template [ngxPermissionsOnly]="'Wolseley'">
                    <button
                        sfButton
                        size="sm"
                        color="secondary"
                        icon="external-link"
                        [disabled]="!canOrderFromWolseley()"
                        (click)="openWolseleyStockCheck()">
                        Check Stock (Wolseley)
                    </button>
                    <a
                        sfButton
                        size="sm"
                        color="secondary"
                        routerLink="/wolseley-order"
                        [disabled]="!canOrderFromWolseley()"
                        [queryParams]="{
                            smartQuoteId: smartquote.id,
                        }"
                        icon="external-link"
                        >Place Order (Wolseley)</a
                    >
                </ng-template>
            </div>
        </div>

        @if (quote?.accepted) {
            <ngb-alert type="success" [dismissible]="false" class="my-3"
                ><p class="text-center mb-0 fw-bold">Quote Accepted</p></ngb-alert
            >
        }
        @if (quote?.declined) {
            <ngb-alert type="success" [dismissible]="false" class="my-3"
                ><p class="text-center mb-0 fw-bold">Quote Declined</p></ngb-alert
            >
            >
        }
    }
</div>
